import * as yup from 'yup'
import { dateRequired, positiveIntegerRequired } from './yup-helper'
import {
  HT_TYREHUB,
  HT_LUBRICANT,
  HT_ECO_BATTERY,
  HT_BRAKES,
  HT_EKOTAYAR
} from '../../constants/companies'

export const MAP_HTG_COMAPNIES = [HT_TYREHUB, HT_LUBRICANT, HT_ECO_BATTERY, HT_BRAKES, HT_EKOTAYAR]

const ALLOWED_HTG_COMPANIES = ['HWT', 'HTL', 'HTE', 'HTB', 'EKT']

const ALLOWED_TYPE = { SALES: 'SALES', QTY: 'QTY', POINT: 'POINT' }

export const ALLOWED_TYPE_VALUES = Object.values(ALLOWED_TYPE)

const contractSchema = yup.object({
  id: yup.number().integer().positive().nullable(),
  fundAmount: yup
    .number()
    .typeError('Fund amount must be a number')
    .integer('Fund amount must be an integer')
    .min(0, 'Fund amount must be 0 or greater')
    .required('Fund amount is required'),
  target: positiveIntegerRequired('Target'),
  contractStartDate: dateRequired('Contract start date'),
  contractEndDate: dateRequired('Contract end date').test(
    'contract-end-date-after-start',
    'Contract end date must be after start date',
    function (value) {
      const { contractStartDate } = this.parent
      if (!value || !contractStartDate) return true
      return value > contractStartDate
    }
  ),
  notes: yup.string().nullable().max(255, 'Note must be at most 255 characters')
})

export const mapSchema = yup.object({
  companyName: yup.string().trim().required('Company name is required'),
  type: yup
    .string()
    .oneOf(ALLOWED_TYPE_VALUES, `Type must be one of: ${ALLOWED_TYPE_VALUES.join(', ')}`)
    .required('Type is required'),
  companyAccountId: yup.string().trim().required('Company account ID is required'),
  htgCompany: yup
    .string()
    .oneOf(ALLOWED_HTG_COMPANIES, `HTG company must be one of: ${ALLOWED_HTG_COMPANIES.join(', ')}`)
    .required('HTG company is required'),
  isCompleted: yup
    .number()
    .oneOf([0, 1], 'Completed is required')
    .required('Completed is required'),
  contracts: yup
    .array()
    .of(contractSchema)
    .min(1, 'At least one contract is required')
    .required()
    .test(
      'contract-contract-start-date-increasing',
      'Each contract must have a start date later than the previous contract',
      (contract) => {
        if (!contract?.length) return true

        for (let i = 1; i < contract.length; i += 1) {
          const prev = contract[i - 1]?.contractStartDate
          const current = contract[i]?.contractStartDate

          if (!prev || !current) continue

          if (new Date(current) <= new Date(prev)) return false
        }

        return true
      }
    )
})
